// Cámara trasera para escanear el QR de un árbol. Solo vídeo, nunca audio.

export type CameraProblem = 'denied' | 'unavailable'

const CONSTRAINTS: MediaStreamConstraints = {
	audio: false,
	video: { facingMode: { ideal: 'environment' }, width: { ideal: 1280 }, height: { ideal: 720 } },
}

// Rechaza si no hay cámara, si el navegador no la ofrece (p. ej. sin HTTPS) o sin permiso.
export const openRearCamera = (
	mediaDevices: Pick<MediaDevices, 'getUserMedia'> | undefined = globalThis.navigator?.mediaDevices
): Promise<MediaStream> =>
	mediaDevices?.getUserMedia
		? mediaDevices.getUserMedia(CONSTRAINTS)
		: Promise.reject(new DOMException('Sin acceso a la cámara', 'NotSupportedError'))

// Distingue "no has dado permiso" (se puede arreglar en los ajustes) de "no hay cámara".
export const cameraProblem = (error: unknown): CameraProblem =>
	error instanceof DOMException && (error.name === 'NotAllowedError' || error.name === 'SecurityError')
		? 'denied'
		: 'unavailable'

export const stopCamera = (stream: Pick<MediaStream, 'getTracks'> | null) => {
	for (const track of stream?.getTracks() ?? []) track.stop()
}
